import { createFeature, createReducer, on } from '@ngrx/store';
import { Document } from '@app/modules/core/store/models';
import { HorizonRatingsActions } from './horizon-ratings.actions';

// selected document should always be Overview Rating document - this will give us some basic doc info for display
// loading and error states here are being used for loaded the related documents
export interface HorizonRatingsState {
  loading: boolean;
  error: Error | null;
  isExpandedViewActive: boolean;
  selectedOverviewDocument: Document | null;
  ratingsDocuments: Document[];
}

const defaultState: HorizonRatingsState = {
  loading: false,
  error: null,
  isExpandedViewActive: false,
  selectedOverviewDocument: null,
  ratingsDocuments: []
};

export const reducer = createReducer(
  defaultState,
  on(HorizonRatingsActions.showExpandedView, (state, { selectedOverviewDocument }) => ({
    ...state,
    selectedOverviewDocument,
    isExpandedViewActive: true
  })),
  // on(HorizonRatingsActions.hideExpandedView, state => ({ ...state, isExpandedViewActive: false })),
  on(HorizonRatingsActions.hideExpandedView, state => {
    return {
      ...state,
      isExpandedViewActive: false
    };
  }),
  on(HorizonRatingsActions.loadRatingsDocuments, state => ({
    ...state,
    loading: true,
    error: null,
    ratingsDocuments: []
  })),
  on(HorizonRatingsActions.loadRatingsDocumentsSuccess, (state, { ratingsDocuments }) => ({ ...state, ratingsDocuments, loading: false })),
  on(HorizonRatingsActions.loadRatingsDocumentsError, (state, { error }) => ({ ...state, error, loading: false, ratingsDocuments: [] })),
  on(HorizonRatingsActions.resetState, () => defaultState)
);

export const HorizonRatingsFeature = createFeature({
  name: 'horizonRatings',
  reducer
});
